import { useEffect, useRef } from "react";
import { BaseModalWrapper, ModalBackdrop } from "./styled";

export const BaseModal = ({
  children,
  open,
  onClose,
  className,
  height,
  width,
}) => {
  const modalRef = useRef();

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose?.(e);
      }
    };

    if (open) {
      window.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.body.style.overflow = "auto";

      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <ModalBackdrop open={open} />
      <BaseModalWrapper
        open={open}
        className={className}
        height={height}
        width={width}
      >
        <div ref={modalRef}>{children}</div>
      </BaseModalWrapper>
    </>
  );
};
